import { render, staticRenderFns } from "./c-money.vue?vue&type=template&id=6b8291c1&scoped=true&"
import script from "./c-money.vue?vue&type=script&lang=js&"
export * from "./c-money.vue?vue&type=script&lang=js&"
import style0 from "./c-money.vue?vue&type=style&index=0&id=6b8291c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8291c1",
  null
  
)

export default component.exports